/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
/* eslint import/prefer-default-export: "off" */
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux';
import {
  firebaseConnect,
  // getFirebase,
  // isLoaded,
  // isEmpty
} from 'react-redux-firebase'

import { withRouter } from 'react-router-dom'

import FlatButton from 'material-ui/FlatButton';

import { command as commandActions } from '../../redux/actions'

const withAction = (WrappedComponent, command) => class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      command,
    }
  }

  render() {
    const { onAction } = this.props
    console.log('onActionRender', this.props);
    return <WrappedComponent onClick={() => onAction(this.state.command)} />
  }
}

const RemoteUp = withAction(props => (
  <button className="button-axes axes-U" {...props}>
    <i className="arrow arrow-up" />
  </button>
), 'UP')

const RemoteDown = withAction(props => (
  <button className="button-axes axes-D" {...props}>
    <i className="arrow arrow-down" />
  </button>
), 'DOWN')

const RemoteLeft = withAction(props => (
  <button className="button-axes axes-L" {...props}>
    <i className="arrow arrow-left" />
  </button>
), 'LEFT')

const RemoteRight = withAction(props => (
  <button className="button-axes axes-R" {...props}>
    <i className="arrow arrow-right" />
  </button>
), 'RIGHT')

const RemoteA = () => (
  <button className="button-circle button-A">A</button>
)

const RemoteB = () => (
  <button className="button-circle button-B">B</button>
)

const RemoteX = () => (
  <button className="button-circle button-X">X</button>
)

const RemoteY = () => (
  <button className="button-circle button-Y">Y</button>
)

const RemoteBL = () => (
  <button className="button-bar button-BL">BL</button>
)

const RemoteBR = () => (
  <button className="button-bar button-BR">BR</button>
)

const RemoteSelect = () => (
  <button className="button-bar-mini button-SELECT">SELECT</button>
)

const RemoteStart = () => (
  <button className="button-bar-mini button-START">START</button>
)


class RemoteControl extends Component {
  componentDidMount() {
    const { setSession, sessionId } = this.props
    setSession(sessionId)
  }

  render() {
    const { sessionId, remoteAction } = this.props
    console.log('sessionId', sessionId);
    return (
      <div className="buttons">
        <p>{sessionId}</p>
        <hr />
        <RemoteA />
        <RemoteB />
        <RemoteX />
        <RemoteY />
        <hr />
        <RemoteUp {...this.props} onAction={remoteAction} />
        <RemoteDown {...this.props} onAction={remoteAction} />
        <RemoteLeft {...this.props} onAction={remoteAction} />
        <RemoteRight {...this.props} onAction={remoteAction} />
        <hr />
        <RemoteBL />
        <RemoteBR />
        <hr />
        <RemoteSelect />
        <RemoteStart />
        <FlatButton label="Default" />
        <hr />
      </div>
    )
  }
}

// <div className="status">NOT CONNECTED</div>
// <QRCode value="http://facebook.github.io/react/" size={200}/>

const mapStateToProps = (state, ownProps) => {
  console.log('mapStateToProps ownProps', ownProps);
  return ({
    context: state.context,
    presence: state.firebase.data && state.firebase.data.presence,
    profile: state.firebase.profile,
    // isLogged: state.auth.isLogged,
    auth: state.firebase.auth,
    settings: state.settings,
    departments: state.firebase.data && state.firebase.data.departments,
  })
};

const mapDispatchToProps = dispatch => bindActionCreators(commandActions, dispatch)

// const firebaseConfigRemote = (props, firebase) => {
const firebaseConfigRemote = (props) => {
  console.log('firebaseConfigRemote:', props);
  return (
    []
  )
}
const ComposedComponent = compose(
  firebaseConnect(firebaseConfigRemote),
  connect(mapStateToProps, mapDispatchToProps),

)(RemoteControl)


// https://stackoverflow.com/questions/42875949/react-router-v4-redirect-not-working
// export default withRouter(connect(mapStateToProps)(App))
const RoutedComponent = withRouter(ComposedComponent)

const Page = (props) => {
  const { match } = props
  const sessionId = match && match.params.sessionId
  return (
    <div>
      <p>RemotePage</p>
      <RoutedComponent {...props} sessionId={sessionId} />
    </div>
  )
}
export default withRouter(Page)



// WEBPACK FOOTER //
// ./src/components/remote/RemoteControl.js